<template>
  <div v-if="isLoading" class="text-center">
    <p>Chargement en cours...</p>
  </div>
  <div v-else class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Modifier un étudiant</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="etudiantForm" @submit="editEtudiant" :validation-schema="etudiantSchema"
        :initial-values="initialValues">
        <div class="row">
          <!-- Nom -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom de l'étudiant <span class="text-danger">*</span>
              </label>
              <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom" />
              <ErrorMessage name="nom" class="text-danger" />
            </div>
          </div>

          <!-- Prénom -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Prénom de l' étudiant <span class="text-danger">*</span>
              </label>
              <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le prenom" />
              <ErrorMessage name="prenom" class="text-danger" />
            </div>
          </div>

          <!-- Email -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Email <span class="text-danger">*</span>
              </label>
              <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer l'email" />
              <ErrorMessage name="email" class="text-danger" />
            </div>
          </div>

          <!-- Sexe -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Sexe <span class="text-danger">*</span>
              </label>
              <Field name="sexe" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="['Masculin', 'Féminin']" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner le sexe" />
              </Field>
              <ErrorMessage name="sexe" class="text-danger" />
            </div>
          </div>

          <!-- Téléphone 1 -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Téléphone 1
              </label>
              <Field name="telephone1" v-slot="{ field }">
                <vue-tel-input :value="field.value || ''" @input="field.onChange($event)" defaultCountry="BJ"
                  mode="international" @validate="validate" class="shadow-none fs-md-15 text-black py-2"
                  placeholder="Entrer le numéro de téléphone" />
              </Field>
              <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correct</div>
              <ErrorMessage name="telephone1" class="text-danger" />
            </div>
          </div>

          <!-- Date de naissance -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de naissance <span class="text-danger">*</span>
              </label>
              <Field name="dateNaissance" type="date" :max="currentDate"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateNaissance" class="text-danger" />
            </div>
          </div>

          <!-- Nationalité -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays de naissance <span class="text-danger">*</span>
              </label>
              <Field name="nationalite" v-slot="{ field }">
                <Multiselect :options="countries" :searchable="true" track-by="value" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le pays de naissance" />
              </Field>
              <ErrorMessage name="nationalite" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Catégorie d'étudiant <span class="text-danger">*</span>
              </label>

              <Field name="categorieEtudiant" v-slot="{ field }">
                <Multiselect
                  :options="categorieEtudiantOptions"
                  track-by="value"
                  label="label"
                  :reduce="option => option.value"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner la catégorie"
                />
              </Field>

              <ErrorMessage name="categorieEtudiant" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Formateur ?
              </label>

              <Field name="categorieFormateur" v-slot="{ field }">
                <Multiselect
                  :options="categorieFormateurOptions"
                  track-by="value"
                  label="label"
                  :reduce="option => option.value"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner la catégorie"
                />
              </Field>

              <ErrorMessage name="categorieFormateur" class="text-danger" />
            </div>
          </div>


          <!-- Commune -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Commune
              </label>
              <Field name="commune">
                <Multiselect :options="communeOptions" v-model="selectedCommune" @change="communeChange"
                  track-by="value" label="label" placeholder="Sélectionner la commune" />
              </Field>

              <ErrorMessage name="commune" class="text-danger" />
            </div>
          </div>

          <!-- Quartier -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Quartier
              </label>
              <Field name="quartier">
                <Multiselect :options="quartierOptions" v-model="selectedQuartier" track-by="value" label="label"
                  placeholder="Sélectionner le quartier" noOptionsText="Sélectionner d'abord une commune" />
              </Field>

              <ErrorMessage name="quartier" class="text-danger" />
            </div>
          </div>

          <!-- Années d'expérience -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nombre d'années d'expériences
              </label>
              <Field name="anneeExperience" type="number" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nombre" />
              <ErrorMessage name="anneeExperience" class="text-danger" />
            </div>
          </div>


          <!-- Qualification -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Qualification <span class="text-danger">*</span>
              </label>
              <Field name="qualification" v-slot="{ field }">
                <Multiselect :options="qualificationOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner la qualification" />
              </Field>
              <ErrorMessage name="qualification" class="text-danger" />
            </div>
          </div>
          <!-- Activités -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Activité <span class="text-danger">*</span>
              </label>
              <Field name="activites" v-slot="{ field }">
                <Multiselect :options="activiteOptions" :searchable="true" mode="tags" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner l'activité" />
              </Field>
              <ErrorMessage name="activites" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Langue <span class="text-danger">*</span>
              </label>
              <Field name="langues" v-slot="{ field }">
                <Multiselect :options="languesOptions" :searchable="true" mode="tags" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner les langues" />
              </Field>
            </div>
            <ErrorMessage name="langues" class="text-danger" />
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Poste occupé actuellement
              </label>
              <Field name="poste" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le poste" />
              <ErrorMessage name="poste" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Catégorie Profesionnelle
              </label>
              <Field name="categorie" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer la categorie" />
              <ErrorMessage name="categorie" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Informations complémentaires 
              </label>
              <Field name="biographie" rows="2" as="textarea" placeholder="Ajouter d'autres informations"
                v-slot="{ field }" class="form-control shadow-none rounded-0 text-black">
                <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
              </Field>
              <ErrorMessage name="biographie" class="text-danger" />
            </div>
          </div>

          <!-- Pièces -->
          <div class="row">
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                <div class="row">
                  <div class="border border-primary mb-1">
                    <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                      style="background-color: #0a59a4">
                      <div class="col-md-7">
                        <h3 class="fs-4 text-white">Pièce(s)</h3>
                      </div>
                      <div class="col-md-5">
                        <div class="d-flex float-end">
                          <button
                            class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                            type="button" :class="{ 'cursor-not-allowed': isDisable }" @click="addRowPiece()">
                            <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                            Ajouter une pièce
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="row gx-1">
                        <div class="col-md-4">
                          <label class="d-block text-black fw-semibold">Type de pièce <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-md-4">
                          <label class="d-block text-black fw-semibold mb-1">Numéro de pièce <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-md-3">
                          <label class="d-block text-black fw-semibold mb-1">Image <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-md-1">
                          <label class="d-block text-black fw-semibold mb-1">Action</label>
                        </div>
                      </div>
                      <hr class="mt-0" />
                      <div class="row gx-1" v-for="(piece, index) in pieces" :key="index">
                        <div class="col-md-4 mb-3">
                          <Field :name="`pieces[${index}].typePiece`" v-slot="{ field }">
                            <Multiselect v-model="pieces[index].typePiece" v-bind="field" :options="typeOptions"
                              :preserve-search="true" :multiple="false" :searchable="true"
                              placeholder="Sélectionner le type de pièce" label="label" track-by="value"
                              value-prop="value" />
                          </Field>
                          <ErrorMessage :name="`pieces[${index}].typePiece`" class="text-danger" />
                        </div>
                        <div class="col-md-4 mb-3" v-if="!isPhotoPiece(pieces[index].typePiece)">
                          <Field type="text" class="form-control shadow-none fs-md-15 text-black"
                            placeholder="Entrer le numéro de la pièce" :name="`pieces[${index}].numeroPiece`"
                            v-model="pieces[index].numeroPiece" />
                          <ErrorMessage :name="`pieces[${index}].numeroPiece`" class="text-danger" />
                        </div>
                        <div class="col-md-4 mb-3" v-else>
                          <small class="text-muted">Aucun numéro requis pour la photo d'identité</small>
                        </div>
                        <div class="col-md-3 mb-3">
                          <Field type="file" accept="image/*" class="form-control"
                            @change="handleFileChange($event, index)" :name="`pieces[${index}].urlImage`" />
                          <!-- Aperçu de l'image existante si pas de nouveau fichier -->
                          <div v-if="(piece as any).urlImageExistante && !piece.urlImage" class="mt-1">
                            <small class="text-muted">Actuel : </small>
                            <a :href="getUrlApiForEtudiantsFiles((piece as any).urlImageExistante)" target="_blank" class="text-primary small">Voir</a>
                          </div>
                          <ErrorMessage :name="`pieces[${index}].urlImage`" class="text-danger" />
                        </div>
                        <div class="col-md-1 mb-3" v-if="index > 0">
                          <button class="btn btn-danger transition border-0 py-1 px-2" type="button"
                            @click="removeRowPiece(index)">
                            <i class="flaticon-delete lh-1 me-0 position-relative top-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Boutons -->
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button ref="submitButton" class="btn btn-success me-3" type="submit" :disabled="isSubmitting">
                <i v-if="!isSubmitting" class="fa fa-save me-2"></i>
                <i v-if="isSubmitting" class="fa fa-spinner fa-spin me-2"></i>
                {{ isSubmitting ? 'Enregistrement...' : "Modifier l'étudiant" }}
              </button>
              <router-link to="/liste-etudiants" class="btn btn-danger">
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import { Form, Field, ErrorMessage, FormContext } from 'vee-validate';
import { useRouter, useRoute } from 'vue-router';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';
import { VueTelInput } from 'vue3-tel-input';
import { success, error, getUrlApiForEtudiantsFiles } from '@/utils/utils';
import { countries } from '../../components/Inscription/countries';
import axios from 'axios';
import { Piece } from '@/models/Piece';

export default defineComponent({
  name: 'EditEtudiant',
  components: { Form, Field, ErrorMessage, Multiselect, VueTelInput },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(true);
    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const etudiantForm = ref<FormContext | null>(null);
    const validPhone = ref<boolean>(true);
    const initialValues = ref<any>({});
    const nationalite = ref('Bénin');
    const isSubmitting = ref(false);
    const isDisable = ref(true);
    const telephone1 = ref('');
    const typeOptions = ref([]);
    const pieces = ref<Piece[]>([{ typePiece: '', numeroPiece: '', urlImage: null }]);

    const languesOptions = ref([]);

    const qualificationOptions = ref([]);
    const activiteOptions = ref([]);
    const communeOptions = ref([]);
    const quartierOptions = ref([]);
    const selectedCommune = ref<number | null>(null);
    const selectedQuartier = ref<number | null>(null);
    const categorieEtudiantOptions = ref([
      { value: 'Habitué', label: 'Habitué' },
      { value: 'Auditeur', label: 'Auditeur' },
      { value: 'Disciple', label: 'Disciple' },
      { value: 'Apprenant', label: 'Apprenant' },
    ]);

    const categorieFormateurOptions = ref([
      { value: 'Tutorat', label: 'Tutorat' },
      { value: 'Animateur', label: 'Animateur' },
    ]);
  


    const etudiantSchema = Yup.object().shape({
      nom: Yup.string().required('Le nom du étudiant est obligatoire'),
      prenom: Yup.string().required('Le prénom du étudiant est obligatoire'),
      sexe: Yup.string().required('Le sexe est obligatoire'),
      npi: Yup.string()
        .matches(/^\d{10}$/, 'La saisie doit avoir exactement 10 chiffres')
        .notRequired(),
      ifu: Yup.string()
        .matches(/^\d{13}$/, 'La saisie doit avoir exactement 13 chiffres')
        .notRequired(),
      email: Yup.string().email('Veuillez entrer un mail valide').notRequired(),
      telephone1: Yup.string().notRequired(),
      categorieEtudiant: Yup.string()
      .required("La catégorie d'étudiant est obligatoire"),

      categorieFormateur: Yup.string()
        .nullable()
        .notRequired(),


      dateNaissance: Yup.date()
        .notRequired()
        .max(new Date(), 'La date de naissance ne peut pas être dans le futur')
        .test(
          'age-minimum',
          'Le étudiant doit avoir au moins 18 ans',
          function (value) {
            if (!value) return false;
            const today = new Date();
            const birthDate = new Date(value);
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            return age >= 18;
          }
        ),
       biographie: Yup.string().notRequired(),
      categorie: Yup.string()
        .notRequired(),
      poste: Yup.string()
        .notRequired(),
      langues: Yup.array()
        .of(Yup.string().required())
        .min(1, 'Au moins une langue est obligatoire'),
      nationalite: Yup.string().required('La nationalité est obligatoire'),
      commune: Yup.number().notRequired(),
      quartier: Yup.number().notRequired(),
      anneeExperience: Yup.number().notRequired(),
      qualification: Yup.number().required('La qualification est obligatoire'),
      activites: Yup.array()
        .of(Yup.string().required())
        .min(1, 'Au moins une activité est obligatoire'),
    });

    const validate = (phoneObject: any) => {
      validPhone.value = phoneObject.valid ?? true;
      if (phoneObject.valid) {
        telephone1.value = phoneObject.number;
      } else {
        telephone1.value = '';
      }
    };

    const isPhotoPiece = (typeId: string) => typeId === '5';

    const addRowPiece = async () => {
      const isValid = await etudiantForm.value?.validate();
      if (!isValid?.valid) {
        error("Veuillez remplir tous les champs de la pièce actuelle avant d'en ajouter une nouvelle.");
        return;
      }
      pieces.value.push({ typePiece: '', numeroPiece: '', urlImage: null });
      isDisable.value = true;
    };

    const removeRowPiece = (index: number) => {
      if (pieces.value.length > 1) {
        pieces.value.splice(index, 1);
      }
    };

    const handleFileChange = (event: Event, index: number) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      pieces.value[index].urlImage = file || null;
    };

    const getAllType = async () => {
      try {
        const response = await ApiService.get('/all/typePieces');
        typeOptions.value = response.data.data.data.map((type: any) => ({
          value: type.id.toString(),
          label: type.libelle,
        }));
        console.log('🔍 typeOptions chargées:', typeOptions.value);
      } catch (err) {
        console.error('Erreur lors du chargement des types de pièces:', err);
      }
    };

    const fetchCommunes = async () => {
      try {
        const { data } = await ApiService.get('/communes');
        console.log('Communes:', data.data);
        communeOptions.value = data.data.data.map((item: any) => ({
          value: item.id,
          label: item.libelle,
        }));
      } catch (err) {
        console.error('Erreur lors du chargement des communes:', err);
        error('Erreur lors du chargement des communes');
      }
    };

    const communeChange = async (value: number | null) => {
      quartierOptions.value = [];
      selectedQuartier.value = null;

      if (value !== null) {
        try {
          const { data } = await ApiService.get(`/communes/quartiers/${value}`);
          quartierOptions.value = data.data.map((quartier: any) => ({
            value: quartier.id,
            label: quartier.libelle,
          }));
        } catch (err) {
          console.error('Erreur lors du chargement des quartiers:', err);
          error('Erreur lors du chargement des quartiers');
        }
      }
    };


    const fetchLangue = async () => {
      try {
        const { data } = await ApiService.get('/langues');
        console.log('Languesdf:', data.data.data);
        languesOptions.value = data.data.data.map((langue: any) => ({
          value: langue.id,
          label: langue.libelle,
        }));
      } catch (err) {
        console.error('Erreur lors du chargement des langues:', err);
        error('Erreur lors du chargement des langues');
      }
    };


    const fetchQualification = async () => {
      try {
        const { data } = await ApiService.get('/all/qualifications');
        console.log('Qualifications:', data.data.data);
        qualificationOptions.value = data.data.data.map((qualification: any) => ({
          value: qualification.id,
          label: qualification.libelle,
        }));
      } catch (err) {
        console.error('Erreur lors du chargement des qualifications:', err);
        error('Erreur lors du chargement des qualifications');
      }
    };

    const fetchActivite = async () => {
      try {
        const { data } = await ApiService.get('/activites');
        console.log('Activités:', data.data.data);
        activiteOptions.value = data.data.data.map((activite: any) => ({
          value: activite.id,
          label: activite.libelle,
        }));
      } catch (err) {
        console.error('Erreur lors du chargement des activités:', err);
        error('Erreur lors du chargement des activités');
      }
    };


    const getEtudiant = async (id: number) => {
      try {
        const { data } = await ApiService.get(`/etudiants/edit/${id}`);
        console.log('Données du étudiant:', data.data);


        const etudiantData = data.data;
        console.log("Réponse brute étudiant :", JSON.stringify(etudiantData, null, 2));

        // Récupération des langues avec plusieurs fallbacks
        // Remplacez cette section dans votre fonction getEtudiant :
let languesIds = [];

// L'API retourne etudiantData.langues comme un tableau d'objets {id, libelle}
if (etudiantData.langues && Array.isArray(etudiantData.langues)) {
  languesIds = etudiantData.langues.map((l: any) => l.id).filter(Boolean);
  console.log(' Langues récupérées depuis etudiantData.langues:', languesIds);
}
// Fallback sur user.langues
else if (etudiantData.user?.langues && Array.isArray(etudiantData.user.langues)) {
  languesIds = etudiantData.user.langues.map((l: any) => l.id).filter(Boolean);
  console.log(' Langues récupérées depuis user.langues:', languesIds);
}

console.log('🔍 languesIds final:', languesIds);
console.log('🔍 languesOptions disponibles:', languesOptions.value);

        initialValues.value = {
          nom: etudiantData.nom || '',
          prenom: etudiantData.prenom || '',
          email: etudiantData.email || '',
          sexe: etudiantData.sexe || '',
          telephone1: etudiantData.telephone1 || etudiantData.user?.telephone || '',
          dateNaissance: etudiantData.dateNaissance ? etudiantData.dateNaissance.split('T')[0] : '',
          biographie: etudiantData.biographie || '',
          categorie: etudiantData.categorie || '',
          poste: etudiantData.poste || '',
          anneeExperience: etudiantData.anneeExperience || null,
          nationalite: etudiantData.nationalite || 'Bénin',
          categorieEtudiant: etudiantData.categorieEtudiant || null,
          categorieFormateur: etudiantData.categorieFormateur || null,
          qualification: etudiantData.qualification?.id || null,
          commune: etudiantData.quartier?.arrondissement?.commune?.id
            || etudiantData.quartier?.commune?.id
            || null,
          quartier: etudiantData.quartier?.id || null,
          activites: etudiantData.userActivites?.map((ua: any) => ua.activite?.id).filter(Boolean)
            || etudiantData.activites?.map((a: any) => a.id).filter(Boolean)
            || [],
          langues: languesIds,
        };

        // Charger les pièces existantes dans le tableau réactif
        if (etudiantData.pieces?.length) {
          console.log('🔍 Debug pièces reçues du backend:', etudiantData.pieces);
          
          pieces.value = etudiantData.pieces.map((p: any) => {
            const typePieceId = p.typePiece?.id?.toString() || p.typePieceId?.toString() || '';
            console.log('🔍 Pièce mappée:', {
              original: p,
              typePieceId: typePieceId,
              typePieceObjet: p.typePiece,
            });
            
            return {
              id: p.id,
              typePiece: typePieceId,
              numeroPiece: p.numeroPiece || '',
              urlImage: null,           // fichier non rechargeable, on garde null
              urlImageExistante: p.urlImage || '', // pour affichage de l'existant
            };
          });
          
          console.log('🔍 Pièces après mapping:', pieces.value);
          console.log('🔍 typeOptions disponibles:', typeOptions.value);
        } else {
          pieces.value = [{ typePiece: '', numeroPiece: '', urlImage: null }];
        }

        // Debug très important
        console.log(" Valeurs extraites pour multiselect :", {
          activites: initialValues.value.activites,
          langues: initialValues.value.langues,
          raw_userActivites: etudiantData.userActivites,
          raw_langues: etudiantData.langues || etudiantData.user?.userLangues?.langues,
        });





        console.log('initialValues:', initialValues.value);
        console.log('commune vvr:', etudiantData.quartier?.commune);
        console.log('arrondisement:', initialValues.value.quartier?.commune);
        console.log('commufffffffffffffffffffne:', initialValues.value.commune);

        if (etudiantData.quartier?.arrondissement?.commune?.id) {

          await communeChange(etudiantData.quartier.arrondissement.commune.id);
          initialValues.value.commune = etudiantData.quartier.arrondissement.commune.id;
          selectedQuartier.value = etudiantData.quartier.id;


        }

      } catch (err: any) {
        console.error('Erreur lors du chargement du étudiant:', err);
        error(err.response?.data?.message || 'Erreur lors du chargement du étudiant');
      }
    };

  const editEtudiant = async (values: any, { resetForm }: any) => {
  if (submitButton.value) submitButton.value.disabled = true;
  isSubmitting.value = true;

  try {
    const id = route.params.id;
    const formData = new FormData();

    // Champs simples
    formData.append('nom', values.nom);
    formData.append('prenom', values.prenom);
    formData.append('sexe', values.sexe);
    formData.append('email', values.email || '');
    formData.append('telephone1', telephone1.value || values.telephone1 || '');
    formData.append('dateNaissance', values.dateNaissance || '');
    formData.append('biographie', values.biographie || '');
    formData.append('categorie', values.categorie || '');
    formData.append('poste', values.poste || '');
    formData.append('anneeExperience', values.anneeExperience?.toString() || '0');
    formData.append('nationalite', values.nationalite || '');
    formData.append('categorieEtudiant', values.categorieEtudiant || '');
    formData.append('categorieFormateur', values.categorieFormateur || '');
    formData.append('quartier', selectedQuartier.value?.toString() || '');
    formData.append('qualificationId', values.qualification?.toString() || '');

    // Tableaux
    (Array.isArray(values.activites) ? values.activites : [])
      .forEach((a: any) => formData.append('activites[]', a.toString()));
    (Array.isArray(values.langues) ? values.langues : [])
      .forEach((l: any) => formData.append('langues[]', l.toString()));

    // Pièces : métadonnées en JSON (même pattern que addEtudiant avec piecesData)
    const piecesData = pieces.value.map((piece: any) => ({
      id: piece.id || null,
      typePiece: piece.typePiece,
      numeroPiece: piece.numeroPiece || null,
      urlImage: piece.urlImageExistante || null, // fichier existant conservé si pas de nouveau
    }));
    formData.append('pieces', JSON.stringify(piecesData));

    // Fichiers indexés : piecesFichiers_0, piecesFichiers_1...
    pieces.value.forEach((piece: any, index: number) => {
      if (piece.urlImage instanceof File) {
        formData.append(`piecesFichiers_${index}`, piece.urlImage);
      }
    });

    await ApiService.put(`/etudiants/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    success('Etudiant modifié avec succès');
    resetForm();
    router.push({ name: 'ListeEtudiantPage' });

  } catch (err: any) {
    error(err.response?.data?.message || 'Erreur lors de la modification');
  } finally {
    isSubmitting.value = false;
    if (submitButton.value) submitButton.value.disabled = false;
  }
};

    onMounted(async () => {
      isLoading.value = true;
      console.log('ID from route:', route.params.id);
      await Promise.all([
        fetchCommunes(),
        fetchLangue(),
        fetchQualification(),
        fetchActivite(),
        getAllType(),
      ]);
      if (route.params.id) {
        await getEtudiant(parseInt(route.params.id as string));
        selectedCommune.value = initialValues.value.commune;
        await communeChange(selectedCommune.value);
        selectedQuartier.value = initialValues.value.quartier;
      }
      isLoading.value = false;
    });

    watch(
      pieces,
      async (newValue) => {
        if (newValue.length === 0) { isDisable.value = false; return; }
        const lastPiece = newValue[newValue.length - 1];
        const isValid = await etudiantForm.value?.validate();
        isDisable.value = !isValid?.valid || !lastPiece.typePiece || !lastPiece.numeroPiece || !lastPiece.urlImage;
      },
      { deep: true }
    );

    return {
      isLoading,
      etudiantSchema,
      initialValues,
      editEtudiant,
      currentDate,
      submitButton,
      etudiantForm,
      validate,
      nationalite,
      countries,
      validPhone,
      communeOptions,
      quartierOptions,
      communeChange,
      selectedCommune,
      selectedQuartier,
      qualificationOptions,
      languesOptions,
      activiteOptions,
      categorieEtudiantOptions,
      categorieFormateurOptions,
      isSubmitting,
      isDisable,
      pieces,
      typeOptions,
      addRowPiece,
      removeRowPiece,
      handleFileChange,
      isPhotoPiece,
      getUrlApiForEtudiantsFiles,
    };
  },
});
</script>